import app from '@/app';
import templateUrl from './plan-search.html';

/* @ngInject */
function PlanSearchController(
  $controller,
  $state,
  DialogService,
  Plan,
  $http,
  Principal,
  $translate,
  AlertService,
  $timeout,
  $scope,
  $rootScope) {
	var $ctrl = this;
	var resource = Plan;
	$ctrl.plans = [];
	$ctrl.entities = [];
	$ctrl.selectAll = false;
  $ctrl.namePlan = "";

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	// Hardcoded instance guard: some actions are only released for the contracted
	// domains (same rule used in the navbar).
	$ctrl.isInstance = isInstance;

	// Accepts a comma-separated list, mirroring the has-authority syntax.
	function isInstance(domains) {
		var baseUrl = $ctrl.currentAccount && $ctrl.currentAccount.baseUrl;
		if (!baseUrl) {
			return false;
		}
		var current = baseUrl.replace(/\/+$/, '');
		return domains.split(',').some(function(domain) {
			return current === 'https://' + domain.trim();
		});
	}

	$controller('AbstractPageSortController', { $ctrl: $ctrl });

	var transition = $ctrl.transition;

	$ctrl.toggleSelectAll = function() {
		var isChecked = $ctrl.selectAll;
		$ctrl.entities.forEach(function(item) {
			item.selectItem = isChecked;
		});
	};


	$ctrl.updatePlans = () => {
		$ctrl.entities.forEach(function(item) {
			if (item.selectItem) {
				$ctrl.plans.push(item.id);
			}
		});

		if ($ctrl.plans.length > 0) {
			$ctrl.selectAll = false;
			$state.go(
				'plan.detail',
				{
					id: 'new'
				},
				{
					reload: false
				}
			);
		} else {
			DialogService.alertMessage($translate.instant('message.selectItem.required'));
		}
	};

   $ctrl.addIdPlans = (id, selectItem) => {
    if (selectItem) {
      $ctrl.plans.push(id);
    } else {
      var index = $ctrl.plans.indexOf(id);
      if (index !== -1) {
        $ctrl.plans.splice(index, 1);
      }
    }
  };

  $ctrl.resultPlans = () => {
    $ctrl.entities.forEach(function (item) {
      if (item.selectItem) {
        $ctrl.plans.push(item.id);
      }
    });

    if ($ctrl.plans.length > 0) {
      $ctrl.selectAll = false;
      $state.go(
        'plan.resultPlans',
        {
          id: $ctrl.plans
        },
        {
          reload: false
        }
      );
    } else {
      DialogService.alertMessage($translate.instant('message.selectItem.required'));
    }
  };

	$ctrl.transition = params => {
		transition(params);
		$ctrl.road = $ctrl.allRoads.content.find(it => it.id == params.road);
		$ctrl.campaigns = _.flow(
			_.keyBy('id'),
			_.at(params.campaigns || [])
		)($ctrl.allCampaigns.content);

		$ctrl.doQuery($ctrl.page, $ctrl.size);

		$http.get('api/projects', { params: { onlyUsed: true } }).then(function(response) {
			$ctrl.allProjects = response.data.content;
		});
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
		$ctrl.campaign = null;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
		$ctrl.campaign = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	/* ----------------------------------------------------------
	 * Shared query function used by both transition and search
	 * ---------------------------------------------------------- */
	$ctrl.doQuery = (page, size) => {
		var pCampaign = $ctrl.campaign && $ctrl.campaign.id ? $ctrl.campaign.id : null;
		var pRoad = $ctrl.road && $ctrl.road.id ? $ctrl.road.id : null;
		var pProject = $ctrl.project && $ctrl.project.id ? $ctrl.project.id : null;
		var pSituationPlan = $ctrl.situationPlan;
		var pOrganization = $ctrl.organization && $ctrl.organization.id ? $ctrl.organization.id : null;

		resource.query(
			{
				organization: pOrganization,
				plantype: 'DEFAULT',
				road: pRoad,
				roadtype: $ctrl.roadtype,
				campaign: pCampaign,
				sort: $ctrl.sort,
				page: page,
				size: size || $ctrl.size,
				project: pProject,
				situationPlan: pSituationPlan,
				query: $ctrl.namePlan
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
			}
		);
	};

	/* ----------------------------------------------------------
	 * DEBOUNCE MANUAL (setTimeout)
	 * ---------------------------------------------------------- */
	let onQueryTimeout = null;

	const executeQuery = () => {
		$ctrl.doQuery(0, $ctrl.size);
	};

	$ctrl.onQueryChange = function() {
		if (onQueryTimeout) {
			clearTimeout(onQueryTimeout);
		}

		onQueryTimeout = setTimeout(() => {
			executeQuery();
		}, 400);
	};

	$ctrl.clearUiSelect = function($event, $select, field) {
		$event.stopPropagation();
		$select.selected = null;
		$select.search = null;

		field = null;
	};

   $ctrl.confirm = (id, name) => {
    if (!$ctrl.readonly) {
      DialogService.confirmDelete(
        {
          type: 'plan',
          count: 1,
          named: name
        },
        () => $ctrl.remove(id, name)
      );
    }
  };

	$ctrl.confirmDeleteSelected = () => {
		if (!$ctrl.readonly && $ctrl.plans.length > 0) {
			// Obter quantidade e texto condicional
			const count = $ctrl.plans.length;
			const named = count > 1 ? count + ' planejamentos selecionados' : '1 planejamento selecionado';
      
			DialogService.confirmDelete(
				{
					type: 'plan',
					count: count,
					named: named
				},
				() => $ctrl.removeSelected()
			);
		}
	};

	$ctrl.removeSelected = () => {
		resource.deleteBatch($ctrl.plans).$promise
			.then(() => {
				$ctrl.plans = [];
				$ctrl.selectAll = false;
				$state.reload();
			})
			.catch((error) => {
				// Exibir alerta com mensagem do global.json se der erro de permissao ou falha
				DialogService.alertMessage($translate.instant('error.delete_permission'));
			});
	};

  $ctrl.confirmDuplicate = entity => {
    if (!$ctrl.readonly) {
      const message = $translate.instant('plan.duplicate.confirm.message', { name: entity.name });
      DialogService.alertMessage(message)
      $state.go('.duplicate', { id: entity.id, name: entity.name });
    }
  };

 $ctrl.confirmPlanNote = plan => {
  if (!$ctrl.readonly && plan) {
    DialogService.confirmPlanNote('message.planNoteText', plan.note, 'message.placeHolderPlanNoteText', { name: plan.name })
      .then(function (result) {
        if (result.confirmed) {
          $ctrl.isSaving = true;
          $http.patch('/api/plans/' + plan.id + '/note', result.text, {
            headers: { 'Content-Type': 'text/plain' }
          }).then(function () {
            plan.note = result.text;
            AlertService.success('entity.note.saved', {
              name: plan.name
            });
            $ctrl.isSaving = false;
          }).catch(function (err) {
            console.error('Failed to save plan note:', err);
            $ctrl.isSaving = false;
          });
        }
      });
  }
};



  $ctrl.confirmSearchDependences = planId => {
    if (!$ctrl.readonly && planId && !$ctrl.loading) {
      DialogService.confirmCheckUpdatedDependencies(
        $translate.instant('dialog.want_check')
      ).then(function (result) {
        // Alterado para DialogService.confirmMessage e aguardando a promessa
        if (result === true) {
          // Verificar se o usuário clicou em "Sim"

          $ctrl.loading = true; // Definir o estado de carregamento como verdadeiro

          $http
            .get('api/plans/UpdatedDependencies', { params: { planId: planId } })
            .then(function (response) {
              var items = response.data.updatedDependencies;
              var templateString = '';

              if (items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                  templateString += $translate.instant('name.' + items[i]) + ', ';
                }
                DialogService.alertMessage(
                  $translate.instant('dialog.have_updated') +
                  response.data.name +
                  '": ' +
                  templateString.slice(0, -2) +
                  '  '
                );
              } else {
                templateString = $translate.instant(
                  'updatedDependencies.nullListDependencies'
                );
                DialogService.alertMessage(templateString);
              }
            })
            .finally(function () {
              $ctrl.loading = false; // Limpar o estado de carregamento, independentemente do resultado
            });
        }
      });
    }
  };

	$ctrl.remove = (id, name) => resource.remove({ id: id }, () => $state.reload()).$promise;

  $ctrl.runPlans = function () {
    $ctrl.isProcessing = true;
    $ctrl.progress = 0;
    $ctrl.count = 0;

    $http.post('/api/plans', plan).then(function (response) {
      $ctrl.count = $ctrl.count + 1;
      $ctrl.progress = ($ctrl.count / totalSize) * 100;
    });

    var totalSize = $ctrl.plans.length;

    var promises = $ctrl.plans.map(function (plan) {
      if (plan.id === null) {
        return $http.post('/api/plans', plan).then(function (response) {
          $ctrl.count = $ctrl.count + 1;
          $ctrl.progress = ($ctrl.count / totalSize) * 100;
        });
      } else {
        return $http.put('/api/plans/' + plan.id, plan).then(function (response) {
          $ctrl.count = $ctrl.count + 1;
          $ctrl.progress = ($ctrl.count / totalSize) * 100;
        });
      }
    });

    Promise.all(promises)
      .then(function () {
        $ctrl.isProcessing = false;
        AlertService.success('entity.updated.plans', {
          type: 'Plan',
          name: ''
        });
        $rootScope.$broadcast('processStatusChanged');
        $state.go('^', {}, { reload: true });
      })
      .catch(function (error) {
        $ctrl.isProcessing = false;
        console.error($translate.instant('dialog.erro_save_all_plan'), error);
      });
  };

}

app.component('planSearch', {
	templateUrl,
	controller: PlanSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCostTables: '<',
		allGrowthRates: '<'
	}
});
